import React from 'react';
import NewHeader from './components/NewHeader';
import { ExpandOutlined } from '@mui/icons-material';
import imgurl from './assests/images/imgurl';
import './assests/css/style.css';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import Drawer from '@mui/material/Drawer';


function Termsncond() {

  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  return (
    <div className="termsncond">

      <div className="blue-shape2">
        <img src={imgurl.shape2} alt="Decorative Shape2" className="decorative-shapetwo" />
      </div>

      <Grid xs={12} className='termsandcond'>
        <Grid xs={4} className='logogrid'>
          <img src={imgurl.logo1} alt="Logo" />
        </Grid>
        <Grid xs={4} className='termscondtext'>
          <p className='thank-youtxt'>Thank <br /> You</p>
          <p className='thank-yousubtxt'>YOU ARE NOW READY TO START USING THE APP. WE BELIEVE EVERYONE DESERVES A FULL HEAD OF HAIR.</p>
        </Grid>
        <Grid xs={4} className='termscondcontent'>
          <p className='pretermstext'>BY CONTINUING YOU AGREE TO OUR</p>
          {/* <Link underline="always">  */}
          <p className='termstext' onClick={() => setOpen(true)}>TERMS AND CONDITIONS</p>
          {/* </Link> */}

          <div className="nextbtn letsgobtn">
            <Button variant="contained" onClick={() => { navigate("/profilepage") }}>
              <div className="nextbtntext termscondbtntxt">
                <p> LET'S GO! </p>
                <img src={imgurl.arrows} alt="Forward arrows" />
              </div>

            </Button>
          </div>

          <Drawer
            className='imguplddrwr trmscnddrwr'
            anchor={'bottom'}
            open={open}
            onClose={() => setOpen(false)}
          >
            <div className='drawerhead'>
              <p></p>
              <div className='ellipse cursor-pointer' onClick={() => setOpen(false)}>
                <p>X</p>
              </div>
            </div>

            <div className="WordSection1">

              <h1>Terms of Use</h1>

              <p className="MsoNormal">Effective Date: 1 Jan, 2025</p>

              <h2>Welcome</h2>

              <p className="MsoNormal">Welcome to the Alopexia website and application! These Terms
                of Use (“Terms”) govern your use of the services (“Service”)  provided by Centa
                Bio (“us,” “we,” or “our”). By accessing or using the Alopexia website and/or
                application, you agree to be bound by these Terms. <br></br>
                <br></br>
              </p>

              <p className="MsoNormal">If you disagree with any part of these Terms, you may not
                access the Service.</p>

              <h2>1. Use of the Service</h2>

              <p className="MsoNormal">Alopexia offers AI-driven personalized haircare solutions,
                including scalp analysis, treatment recommendations, and progress tracking. The
                Service is designed to provide actionable insights and personalized treatment
                options for users experiencing hair loss.<br></br>
                <br></br>
                By using the Service, you agree to:<br></br>
                - Use the Service only for personal, non-commercial purposes.<br></br>
                - Follow all applicable laws and regulations in your use of the Service.</p>

              <h2>2. Eligibility</h2>

              <p className="MsoNormal">You must be at least 18 years old and a male to use the
                Service and capable of entering into a lawful agreement. By using the Service,  you
                confirm that you meet these eligibility criteria.</p>

              <h2>3. Account Creation</h2>

              <p className="MsoNormal">Certain features may require you to create an account. You
                agree to:<br></br>
                - Provide accurate and up-to-date information during registration.<br></br>
                - Maintain the confidentiality of your account credentials.<br></br>
                - Notify us immediately of any unauthorized access to your account.<br></br>
                <br></br>
                You are solely responsible for activities under your account.</p>

              <h2>4. Acceptable Use</h2>

              <p className="MsoNormal">When using the Service, you agree not to:<br></br>
                - Interfere with or disrupt the functionality of the Service.<br></br>
                - Use the Service for illegal or unauthorized purposes.<br></br>
                - Upload harmful content, such as viruses, worms, or other malicious software.<br></br>
                - Engage in any activity that compromises the security or integrity of the
                Service.</p>

              <h2>5. Intellectual Property Rights</h2>

              <p className="MsoNormal">All content, features, and functionality of the Service are
                the exclusive property of Centa Bio. <br></br>
                Unauthorized use of trademarks, logos, or proprietary materials is prohibited
                without prior written consent.</p>

              <h2>6. Privacy</h2>

              <p className="MsoNormal">Your use of the Service is governed by our Privacy Policy,
                which outlines how we collect, use, and protect your personal information,
                including sensitive health data. Please review our Privacy Policy for more
                details.</p>

              <h2>7. Data Usage and Sharing</h2>

              <p className="MsoNormal">By using the Service, you agree to:<br></br>
                - Allow Centa Bio to collect and process data, including health-related data,
                to deliver personalized solutions.<br></br>
                - Consent to data aggregation for research and service improvement.<br></br>
                - Understand that we will not share your personally identifiable information
                without your explicit consent, except as required by law.</p>

              <h2>8. Disclaimer of Warranties</h2>

              <p className="MsoNormal">The Service is provided on an “as is” and “as available”
                basis. Centa Bio does not guarantee uninterrupted access, error-free
                functionality, or the accuracy of the results generated by the AI-driven
                analysis.</p>

              <h2>9. Limitation of Liability</h2>

              <p className="MsoNormal">To the fullest extent permitted by law, Centa Bio shall not
                be liable for:<br></br>
                - Indirect, incidental, or consequential damages.<br></br>
                - Loss of data, profits, or goodwill arising from your use of the Service.</p>

              <h2>10. Changes to the Terms of Use</h2>

              <p className="MsoNormal">We reserve the right to update these Terms at any time. Any
                changes will be posted on this page, with the updated effective date. Continued
                use of the Service constitutes acceptance of the revised Terms.</p>

              <h2>11. Governing Law</h2>

              <p className="MsoNormal">These Terms shall be governed by and construed in accordance
                with the laws of [Insert Governing Jurisdiction], without regard to its
                conflict of law principles.</p>

              <h2>12. Contact Us</h2>

              <p className="MsoNormal">For questions or concerns regarding these Terms, please
                contact us at:<br></br>
                <span >- Email: [Email Address]<br></br>
                  - Address: [Company Address]</span><br></br>
                <br></br>
                By accessing or using the Alopexia website and application, you acknowledge
                that you have read, understood, and agree to these Terms of Use.</p>

            </div>

          </Drawer>

        </Grid>
      </Grid>

      <div className='shapeblue'>
        <img src={imgurl.shapeblue} alt="Blue shape" />
      </div>


    </div>
  )
}

export default Termsncond